<template>
  <div class="loader-container" v-if="!isLoaded">
    <div class="backdrop"></div>
    <div class="dot-spinner">
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
      <div class="dot-spinner__dot"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LbrxLoaderSpinner",
  props: {
    isLoaded: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.isloaded = true;
      }
    };
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
.loader-container {
  position: fixed;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  pointer-events: none;
}

.backdrop {
  position: fixed;
  backdrop-filter: blur(5px);
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  pointer-events: auto;
}

.dot-spinner {
  --uib-size: 2.8rem;
  --uib-speed: 0.9s;
  --uib-color: #028fcab3;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  block-size: var(--uib-size);
  inline-size: var(--uib-size);
}

.dot-spinner__dot {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
}

.dot-spinner__dot::before {
  border-radius: 50%;
  animation: pulse0112 calc(var(--uib-speed) * 1.111) ease-in-out infinite;
  background-color: var(--uib-color);
  block-size: 20%;
  box-shadow: 0 0 20px rgba(18, 31, 53, 30%);
  content: "";
  inline-size: 20%;
  opacity: 0.5;
  transform: scale(0);
}

.dot-spinner__dot:nth-child(2) {
  transform: rotate(45deg);
}

.dot-spinner__dot:nth-child(2)::before {
  animation-delay: calc(var(--uib-speed) * -0.875);
}

.dot-spinner__dot:nth-child(3) {
  transform: rotate(90deg);
}

.dot-spinner__dot:nth-child(3)::before {
  animation-delay: calc(var(--uib-speed) * -0.75);
}

.dot-spinner__dot:nth-child(4) {
  transform: rotate(135deg);
}

.dot-spinner__dot:nth-child(4)::before {
  animation-delay: calc(var(--uib-speed) * -0.625);
}

.dot-spinner__dot:nth-child(5) {
  transform: rotate(180deg);
}

.dot-spinner__dot:nth-child(5)::before {
  animation-delay: calc(var(--uib-speed) * -0.5);
}

.dot-spinner__dot:nth-child(6) {
  transform: rotate(225deg);
}

.dot-spinner__dot:nth-child(6)::before {
  animation-delay: calc(var(--uib-speed) * -0.375);
}

.dot-spinner__dot:nth-child(7) {
  transform: rotate(270deg);
}

.dot-spinner__dot:nth-child(7)::before {
  animation-delay: calc(var(--uib-speed) * -0.25);
}

.dot-spinner__dot:nth-child(8) {
  transform: rotate(315deg);
}

.dot-spinner__dot:nth-child(8)::before {
  animation-delay: calc(var(--uib-speed) * -0.125);
}

@keyframes pulse0112 {
  0%,
  100% {
    opacity: 0.5;
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
